module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_pregnant_right-8c50893fad8fe1bef8130fa582633263.png";